export default __webpack_public_path__ + "91f65eb6d79de73c44bd19a72e47734b.png";